<template>
  <bottom-bar class="audio-detail-bottom-bar"
              :benefit-bar="benefitBar"
              :sell="sell"
              :product="formatProduct"
              :render-price="renderPrice"
              :action-bar="actionBar"
              :my-team-id="myTeamId"
              :page-guide-info="pageGuideInfo"
              :modal-guide-info="modalGuideInfo"
  >
    <template #left>
      <left-slot :trial-programs="trialPrograms"
                 :collect="collect"
                 :target-id="audioId"
                 target-type="audio"
      />
    </template>
  </bottom-bar>
</template>

<script>
  import validator from '@/utils/validator';
  import BottomBar from '@/components/ProductDetailBottom/Bar';
  import LeftSlot from '@/components/ProductDetailBottom/LeftSlot';

  export default {
    name: 'AudioDetailBottomBar',
    components: {
      BottomBar,
      LeftSlot,
    },
    data() {
      return {
        isSetList: false,
      };
    },
    props: {
      audioId: {
        require: true,
        type: Number,
        default: 0,
      },
      product: {
        type: Object,
        required: true,
      },
      benefitBar: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      trialPrograms: {
        type: Array,
        required: true,
      },
      sell: {
        type: Object,
        required: true,
      },
      renderPrice: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      actionBar: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      myTeamId: {
        type: Number,
        default: 0,
      },
      pageGuideInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      modalGuideInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      collect: {
        validator(val) {
          return validator.isObject(val);
        },
      },
    },
    computed: {
      formatProduct() {
        return Object.assign(this.product, { type: 'audio' });
      },
    },
  };
</script>
